import { combineReducers } from 'redux'
import { userInfo } from './userInfo'
import { filterInfo } from './filterInfo'
import { language } from './language'
import { simulationFilterInfo } from './simulationFilterInfo'
import { modalDisplayFlg } from './modalDisplayFlg'
import { searchCriteria } from './searchCriteria'
import signUpClientReducer from './signUpClientReducer'

export default combineReducers({
    userInfo,
    filterInfo,
    signUpClientReducer,
    language,
    simulationFilterInfo,
    modalDisplayFlg,
    searchCriteria
})
